import '@frete.com/fuel-fonts/satoshi/fontface.css';
import React, { JSX } from 'react';
import { ThemeProvider } from 'styled-components';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';

import GlobalStyle from '@/assets/styles/global';
import { Toasts } from '@/components';
import { AppContextProvider } from '@/context';
import { Page } from '@/page';
import { ToastProvider } from '@/context/ToastProvider';

export const RiskManagementRegisterResend: React.FC = () => {
  const fallbackRender = (): JSX.Element => null;

  return (
    <AppContextProvider>
      <ThemeProvider theme={dsTokens}>
        <ToastProvider>
          <Toasts />
          <Outlet />
          <GlobalStyle />
          <ErrorBoundary fallbackRender={fallbackRender}>
            <Page />
          </ErrorBoundary>
        </ToastProvider>
      </ThemeProvider>
    </AppContextProvider>
  );
};

export default RiskManagementRegisterResend;
